<template>
  <div class="tw-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="tw-text-xs required">{{ $t('currency.currencyNameEN') }}</label>
        <input
          v-model="model.currency_name_en"
          type="text"
          class="form-control"
          :placeholder="$t('currency.currencyNameEN')"
          :class="{ 'is-invalid': errors.has('currency_name_en') }"
        />
        <div
          class="invalid-feedback tw-text-xs"
          v-if="errors.has('currency_name_en')"
        >
          {{ errors.first('currency_name_en') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="tw-text-xs">{{ $t('currency.currencyNameKH') }}</label>
        <input
          v-model="model.currency_name_kh"
          type="text"
          class="form-control"
          :placeholder="$t('currency.currencyNameKH')"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="tw-text-xs required">{{ $t('currency.code') }}</label>
        <input
          v-model="model.currency_code"
          type="text"
          class="form-control"
          :placeholder="$t('currency.code')"
          :class="{ 'is-invalid': errors.has('currency_code') }"
        />
        <div
          class="invalid-feedback tw-text-xs"
          v-if="errors.has('currency_code')"
        >
          {{ errors.first('currency_code') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="tw-text-xs">{{
          $t('currency.description')
        }}</label>
        <input
          v-model="model.currency_description"
          type="text"
          class="form-control"
          :placeholder="$t('currency.description')"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required tw-text-xs">{{ $t('currency.symbol') }}</label>
        <input
          v-model="model.currency_symbol"
          type="text"
          class="form-control"
          :placeholder="$t('currency.symbol')"
          :class="{ 'is-invalid': errors.has('currency_symbol') }"
        />
        <div
          class="invalid-feedback tw-text-xs"
          v-if="errors.has('currency_symbol')"
        >
          {{ errors.first('currency_symbol') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required tw-text-xs">{{ $t('currency.rounding') }}</label>
        <input
          v-model.number="model.currency_rounding"
          type="number"
          class="form-control"
          :placeholder="$t('currency.rounding')"
          :class="{ 'is-invalid': errors.has('currency_rounding') }"
        />
        <div
          class="invalid-feedback tw-text-xs"
          v-if="errors.has('currency_rounding')"
        >
          {{ errors.first('currency_rounding') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required tw-text-xs">{{
          $t('currency.compareToDefaultCurrency')
        }}</label>
        <div class="tw-flex compare-currency">
          <div class="tw-w-5/12 left">
            <Input
              v-model="default_currency"
              disabled
              class="tw-rounded-l-none"
            />
          </div>
          <div class="tw-w-2/12 tw-text-center ">
            <Select v-model="model.compare_to_default_currency">
              <Option value=">" v-html="'>'"></Option>
              <Option value="=" v-html="'='"></Option>
              <Option value="<" v-html="'<'"></Option>
            </Select>
          </div>
          <div class="tw-w-5/12 right">
            <Input
              v-model="model.currency_code"
              disabled
              class="tw-rounded-r-none"
            />
          </div>
        </div>
        <div
          class="invalid-feedback tw-text-xs"
          v-if="errors.has('compare_to_default_currency')"
        >
          {{ errors.first('compare_to_default_currency') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ts-checkbox v-model="model.is_default" :class="{ 'is-invalid': errors.has('is_default') }">{{
          $t('currency.default')
        }}</ts-checkbox>
        <div class="validate text-danger tw-text-xs" v-if="errors.has('is_default')">
          {{ errors.first('is_default') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 tw-mt-3 tw-text-right">
        <ts-button class="tw-mr-2" @click.prevent="() => $emit('cancel')">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
          >{{ $t('save') }}</ts-button
        >
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
          >{{ $t('update') }}</ts-button
        >
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { isEmpty } from "lodash";

export default {
  name: 'currencyForm',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_new: false,
      default_currency: null,
      model: {
        currency_id: null,
        currency_code: null,
        currency_name_en: null,
        currency_name_kh: null,
        currency_description: null,
        currency_symbol: null,
        currency_rounding: 2,
        compare_to_default_currency: '=',
        is_default: false
      }
    }
  },
  computed: {
    ...mapState('exchangeRate/currency', ['edit_data']),
    isUpdate() {
      return !isEmpty(this.edit_data)
    }
  },
  async created() {
        await this.getPreData({
            params: {
                currency_id: this.model.currency_id
            },
            index: undefined
        });
    },
  methods: {
    async getPreData({ params, index }) {
      this.loading = true
      this.$store
        .dispatch('exchangeRate/currency/getFormViewModel', {
          index: index,
          params: params
        })
        .then(response => {
          this.default_currency = response.data.default
            ? response.data.default.currency_code
            : null
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave() {
      this.errors = new Errors();
      this.waiting = true
      this.$store
        .dispatch('exchangeRate/currency/store', this.model)
        .then(response => {
					this.notice({ type: 'success', text: response.message })
					this.$emit('cancel')
					this.$emit('fetchData')
				})
				.catch(error => {
					this.errors = new Errors(error.errors)
					this.notice({ type: 'error', text: error.message })
				})
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.errors = new Errors();
      this.waiting = true
      this.$store
        .dispatch('exchangeRate/currency/update', {
          id: this.model.currency_id,
          data: this.model
        })
        .then(response => {
					this.notice({ type: 'success', text: response.message })
					this.$emit('cancel')
					this.$emit('fetchData')
				})
				.catch(error => {
					this.errors = new Errors(error.errors)
					this.notice({ type: 'error', text: error.message })
				})
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.currency_id = this.edit_data.currency_id
        this.model.currency_code = this.edit_data.currency_code
        this.model.currency_name_en = this.edit_data.currency_name_en
        this.model.currency_name_kh = this.edit_data.currency_name_kh
        this.model.currency_description = this.edit_data.currency_description
        this.model.currency_symbol = this.edit_data.sign
        this.model.currency_rounding = this.edit_data.currency_rounding
        this.model.compare_to_default_currency = this.edit_data.compare_to_default_currency
        this.model.is_default = this.edit_data.is_default
      }
    },
    clearInput() {
      this.errors = new Errors();
      this.model.currency_id = null;
      this.model.currency_code = null;
      this.model.currency_name_en = null;
      this.model.currency_name_kh = null;
      this.model.currency_description = null;
      this.model.currency_symbol = null;
      this.model.currency_rounding = 2;
      this.model.compare_to_default_currency = '=';
      this.model.is_default = null;
    },
    notice(not) {
            this.$Notice[not.type]({
                title: "CURRENCY",
                desc: not.text
            });
        }
  }
}
</script>
<style>
.ivu-select-arrow {
  display: none !important;
}
.ivu-select-selected-value {
  padding-right: 8px !important;
}
.compare-currency .ivu-select-selection {
  border-radius: 0;
}
.compare-currency .left .ivu-input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.compare-currency .right .ivu-input {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
</style>
